
const getOpenTranscriptsModalProps = (docProps) => {
    return {
        close: jest.fn(),
        document: {...docProps},
        documentId: 4830169,
        entity: {
            archivedDocuments: [{
                adminOnly: null,
                bankEditable: false,
                category: "business_entity",
                comment: null,
                confirmed: false,
                creditDoc: false,
                custom: false,
                deletable: false,
                description: null,
                displayCommentable: true,
                documentKey: "f2e6ef0a3a52a39ec44acc9f21ac335a550cde34",
                editable: true,
                esignReminderSentAt: null,
                esignStatus: "completed",
                esignable: true,
                esigned: true,
                fileUrls: [{
                    filename: "CertificateLlcMembers_Signed_f2e6ef0a3a52a39ec44acc9f21ac335a550cde34",
                    link: "/admin/loans/224100/download_file?document=5090567&filename=CertificateLlcMembers_Signed_f2e6ef0a3a52a39ec44acc9f21ac335a550cde34.pdf",
                    rid: 966630858
                }],
                filenames: ["CertificateLlcMembers_Signed_f2e6ef0a3a52a39ec44acc9f21ac335a550cde34"],
                files: [{
                    details: null,
                    filestatus: "pending_review",
                    isNew: true,
                    name: "CertificateLlcMembers_Signed_f2e6ef0a3a52a39ec44acc9f21ac335a550cde34",
                    referenceDate: "2020-03-30",
                    rid: 473653265,
                    status: "PENDING",
                    uuid: "1c8a4d08-a718-41f6-a4c1-0c12cb609bba",
                }],
                hasUploadNotifications: true,
                headerImageUrl: null,
                helloSignRoles: [
                    {
                        label: "Authorized Signer",
                        rid: "7890123",
                        value: "signer"
                    }
                ],
                esignSigners: [{
                    email: "michael+test@smartbizloans.com",
                    name: "Michael Toback",
                    rid: 301234566,
                    role: "signer"
                }],
                helloSignTemplateId: "abcedf12345",
                id: "123456778",
                instructions: "Provide details of your LLC's membership",
                live: true,
                phase: "main",
                reference_files: "[]",
                rid: 123,
                signatureRequests: [],
                skippable: false,
                skipped: false,
                status: 'pending_review',
                title: 'Certificate of Limited Liability',
                type: 'Document::CertificateLlcMembers',
                uploaded: true,
            }],
            borrowerType: "oc",
            corporateGuarantors: [],
            correctTaxFormId: 2,
            documents: [],
            financial: {
                fiscalYearEndOn: "12/31/2018",
                lastTaxReturnOn: "12/31/2019"
            },
            fiscalYears: [{
                period: "tax",
                rid: 12345,
                year: 2019
            },
                {
                    period: "tax",
                    rid: 12346,
                    year: 2018
                }, {
                    period: "tax",
                    rid: 12347,
                    year: 2017
                }, {
                    period: "tax",
                    rid: 12348,
                    year: 2016
                }, {
                    period: "tax",
                    rid: 12395,
                    year: 2015
                }],
            guarantors: [{
                archivedDocuments: [],
                business: {
                    rid: 34245,
                },
                documents: [],
                email: "michael.toback+test@smartbizloans.com",
                fiscalYears: [
                    {
                        period: "tax",
                        rid: 22345,
                        year: 2019
                    },
                    {
                        period: "tax",
                        rid: 22346,
                        year: 2018
                    }, {
                        period: "tax",
                        rid: 22347,
                        year: 2017
                    }, {
                        period: "tax",
                        rid: 22348,
                        year: 2016
                    }, {
                        period: "tax",
                        rid: 22395,
                        year: 2015
                    }
                ],
                name: "Michael Toback",
                rid: 13579,
                seniorStaff: [],
                taxAddress: {
                    apt: null,
                    rid: 91234,
                    city: "Saratoga",
                    street: "12345 Main Street",
                    state: "CA",
                    zip: 95070
                },
                taxReturnUrls: [{
                    date: 2019,
                    value: "/admin/loans/224100/download_file?document=5090611\", label: \"2019\", __typename: \"SelectorOption\", Symbol(id): \"SelectorOption/admin/loans/224100/download_file?document=50906112019"
                },
                    {
                        date: 2018,
                        value: "/admin/loans/224100/download_file?document=5090611\", label: \"2018\", __typename: \"SelectorOption\", Symbol(id): \"SelectorOption/admin/loans/224100/download_file?document=50906112018"
                    },
                    {
                        date: 2017,
                        value: "/admin/loans/224100/download_file?document=5090611\", label: \"2017\", __typename: \"SelectorOption\", Symbol(id): \"SelectorOption/admin/loans/224100/download_file?document=50906112017"
                    }],
                taxReturns: [{
                    formId: 1,
                    rid: 54634,
                    formName: "1040C",
                    formYear: 2019
                },
                    {
                        formId: 1,
                        rid: 54635,
                        formName: "1040C",
                        formYear: 2018
                    }, {
                        formId: 1,
                        rid: 54636,
                        formName: "1040C",
                        formYear: 2017
                    }, {
                        formId: 1,
                        rid: 54637,
                        formName: "1040C",
                        formYear: 2016
                    }],
                useBusinessTaxReturns: false
            }],
            name: "Michael Toback Company",
            rid: 12888,
            seniorStaff: [],
            taxAddress: {
                apt: null,
                rid: 91234,
                city: "Saratoga",
                street: "12345 Main Street",
                state: "CA",
                zip: 95070
            },
            taxReturnUrls: [{
                date: 2019,
                value: "/admin/loans/224100/download_file?document=5090611\", label: \"2019\", __typename: \"SelectorOption\", Symbol(id): \"SelectorOption/admin/loans/224100/download_file?document=50906112019"
            },
                {
                    date: 2018,
                    value: "/admin/loans/224100/download_file?document=5090611\", label: \"2018\", __typename: \"SelectorOption\", Symbol(id): \"SelectorOption/admin/loans/224100/download_file?document=50906112018"
                },
                {
                    date: 2017,
                    value: "/admin/loans/224100/download_file?document=5090611\", label: \"2017\", __typename: \"SelectorOption\", Symbol(id): \"SelectorOption/admin/loans/224100/download_file?document=50906112017"
                }],
            taxReturns: [{
                formId: 1,
                rid: 54634,
                formName: "1040C",
                formYear: 2019
            },
                {
                    formId: 1,
                    rid: 54635,
                    formName: "1040C",
                    formYear: 2018
                }, {
                    formId: 1,
                    rid: 54636,
                    formName: "1040C",
                    formYear: 2017
                }, {
                    formId: 1,
                    rid: 54637,
                    formName: "1040C",
                    formYear: 2016
                }],
        },
        getHelloSignUrl: jest.fn(),
        hs: {
            clientId: "123456789",
            testMode: true
        },
        loan: {
            affiliates: [],
            appNumber: 11222,
            businesses: [],
            cre: false,
            creditMemoAuthWarnings: [],
            flowVariant: "five_phase_multiproduct_sba_data_docs_no_ssn",
            id: "sdfkjhsdfjk",
            lastTaxReturnOnOptions: [],
            multiproductFlow: true,
            noTranscriptFlow: true,
            rid: 123123
        },
        resourceType: "business",
        taxReturnOrderInfo: jest.fn(),
        updateTaxReturns: jest.fn()
    }
}

export default getOpenTranscriptsModalProps;